import { render, staticRenderFns } from "./DyestuffFormList2.vue?vue&type=template&id=b71a8a3c&"
import script from "./DyestuffFormList2.vue?vue&type=script&lang=ts&"
export * from "./DyestuffFormList2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports